export const NATURSKADE = {
  isHidden: true,
  nickname: 'PRODUCTS.NATURSKADE.nickname',
  icon: 'naturskade'
};
